export const urlRegex = /(https?:\/\/(?:www\.)?(?:instagram\.com|tiktok\.com|facebook\.com|fb\.watch|vimeo\.com|youtube\.com|youtu\.be|soundcloud\.com|dailymotion\.com|twitch\.tv|x\.com|twitter\.com)\/[^\s]+)/;

const extractMediaUrl = (text) => {
    if (!text) return { textWithoutUrl: '', mediaUrl: null };

    const match = text.match(urlRegex);

    if (match && match[0]) {
        const mediaUrl = match[0];
        const textWithoutUrl = text.replace(urlRegex, '').trim();
        return { textWithoutUrl, mediaUrl };
    }

    return { textWithoutUrl: text, mediaUrl: null };
};

export default extractMediaUrl;